import clsx from "clsx";
import { UserColor } from "../../models";
import styles from "./styles.module.scss";

interface IProps {
  color: UserColor;
  isProd: boolean;
  size: "small" | "large";
}

const UserBadge = ({ color, isProd, size = "small" }: IProps) => {
  if (!isProd) {
    return (
      <div
        className={clsx(styles.testContainer, {
          [styles.large]: size === "large",
        })}
      >
        Test
      </div>
    );
  }

  if (color === "1_new_red" || color === "6_new_green") {
    return (
      <div
        className={clsx(styles.newContainer, {
          [styles.large]: size === "large",
        })}
      >
        New
      </div>
    );
  }

  return null;
};

export default UserBadge;
